import { createSelector } from 'reselect';
import _ from 'lodash';
import moment from 'moment';

import islSort from 'src/helpers/islSort';

const getValueToOrderBy = (orderByParts, item) => {
  // For Date field
  if (orderByParts[0] === 'closedDate') {
    return moment(item.closedDate).valueOf();
  }

  // For Product field
  if (orderByParts[0] === 'product') {
    return item.product;
  }

  // For Numeric fields
  if (orderByParts[0] === 'paidTotal') {
    return item.paidTotal;
  }

  // For Other fields
  return orderByParts.reduce((acc, orderByPart) => {
    return acc + (item[orderByPart] || '');
  }, '');
};

export const sortClaims = (claims, criteria) => {
  const orderByParts = criteria.claimsOrderBy.split('+');

  return [...claims].sort((a, b) => {
    const valueA = getValueToOrderBy(orderByParts, a);
    const valueB = getValueToOrderBy(orderByParts, b);

    let sorted;

    if (orderByParts[0] === 'closedDate' || orderByParts[0] === 'paidTotal') {
      sorted = valueA - valueB; // Numeric comparison
    } else {
      sorted = islSort(valueA, valueB); // Text comparison
    }

    return criteria.claimsOrderDesc ? -1 * sorted : sorted;
  });
};

export const secondaryClaimSelector = createSelector([(args) => args], (claims) => {
  return _.filter(claims, (x) => {
    return x.product !== 'LegalCollection2' && x.product !== 'LegalCollection';
  });
});

export const legalClaimSelector = createSelector([(args) => args], (claims) => {
  return _.filter(claims, (x) => {
    return x.product === 'LegalCollection2' || x.product === 'LegalCollection';
  });
});
